"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _angieslistAppPlatform = require("angieslist-app-platform");
var memberMgmtGatewayService = {
  fetchUser: function fetchUser(userId) {
    return _angieslistAppPlatform.httpClient.get("/gateway/member-management/v1/user/".concat(userId));
  },
  updateUser: function updateUser(data) {
    return _angieslistAppPlatform.httpClient.post('/gateway/member-management/v1/user/update', {
      body: data
    });
  },
  deleteUserAddress: function deleteUserAddress(userAddressId) {
    return _angieslistAppPlatform.httpClient.del("/gateway/member-management/v1/user/addresses/".concat(userAddressId));
  },
  setPrimaryAddress: function setPrimaryAddress(userAddressId) {
    return _angieslistAppPlatform.httpClient.put("/gateway/member-management/v1/user/addresses/primary/".concat(userAddressId));
  },
  changePassword: function changePassword(oldPassword, newPassword) {
    return _angieslistAppPlatform.httpClient.post('/gateway/member-management/v1/user/password/change', {
      body: {
        oldPassword: oldPassword,
        newPassword: newPassword
      }
    });
  },
  getUserContactPreferences: function getUserContactPreferences(userId) {
    return _angieslistAppPlatform.httpClient.get("/gateway/member-management/v1/member/".concat(userId, "/preferences"));
  },
  saveUserContactPreferences: function saveUserContactPreferences(data) {
    return _angieslistAppPlatform.httpClient.post('/gateway/member-management/v1/member/preferences', {
      body: data
    });
  },
  getMembershipInformation: function getMembershipInformation(userId) {
    return _angieslistAppPlatform.httpClient.get("/gateway/member-management/v1/member/".concat(userId, "/subscriptions"));
  },
  getEligibleForRefund: function getEligibleForRefund() {
    return _angieslistAppPlatform.httpClient.get('/gateway/member-management/v1/member/subscription/refundable');
  },
  cancelAutoRenew: function cancelAutoRenew() {
    return _angieslistAppPlatform.httpClient.post('/gateway/member-management/v1/member/subscriptions/donotrenew');
  },
  getUserContactPreferencesByEmail: function getUserContactPreferencesByEmail(email, apiToken) {
    return _angieslistAppPlatform.httpClient.get("/gateway/member-management/v1/member/preferences?email=".concat(email), {
      headers: {
        Authorization: apiToken
      }
    });
  },
  saveUserContactPreferencesByEmail: function saveUserContactPreferencesByEmail(_ref) {
    var email = _ref.email,
      apiToken = _ref.apiToken,
      preferences = _ref.preferences;
    return _angieslistAppPlatform.httpClient.post('/gateway/member-management/v1/member/preferences/unauth', {
      body: {
        email: email,
        preferences: preferences
      },
      headers: {
        Authorization: apiToken
      }
    });
  },
  submitPrivacyRequest: function submitPrivacyRequest(_ref2) {
    var email = _ref2.email,
      privacyRequestType = _ref2.privacyRequestType;
    return _angieslistAppPlatform.httpClient.post('/gateway/member-management/v1/user/privacy-request', {
      body: {
        email: email,
        privacyRequestType: privacyRequestType
      }
    });
  },
  verifyPrivacyRequest: function verifyPrivacyRequest(_ref3) {
    var email = _ref3.email,
      verificationToken = _ref3.verificationToken,
      requestStatus = _ref3.requestStatus;
    return _angieslistAppPlatform.httpClient.post('/gateway/member-management/v1/user/privacy-request/verify', {
      body: {
        email: email,
        verificationToken: verificationToken,
        requestStatus: requestStatus
      }
    });
  }
};
var _default = exports["default"] = memberMgmtGatewayService;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/services/memberMgmtGatewayService.js
// module id = 4252
// module chunks = 9